import { Accordion, AccordionDetails, AccordionSummary, Box, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { KvixIcon } from "../../icons";
import { Text } from "../../Primitives";
const useStyles = makeStyles((theme) => ({
    faqContainer: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: "60px 24px",
        backgroundImage: (props) => `url(${props.backgroundImage || "/assets/about-images/faq-cover.jpg"})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        [theme.breakpoints.up("sm")]: {
            padding: "120px 24px"
        }
    },
    faqAccordion: {
        "&.MuiAccordion-root.Mui-expanded": {
            margin: 0,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            borderTop: "1px solid rgba(0, 0, 0, 0.12)"
        }
    },
    titleText: {
        paddingBottom: " 20px "
    }
}));
export const FaQ = (props) => {
    const classes = useStyles(props);
    const [expandedIndex, setExpandedIndex] = useState(0);
    const { t, ready } = useTranslation("startPage");
    if (!ready) {
        return null;
    }
    return (React.createElement("div", { className: classes.faqContainer },
        React.createElement(Text, { variant: props.isMobile ? "h1" : "h2", className: classes.titleText }, (props.title !== undefined && props.title) ||
            (props.title === undefined && t("recruitLandingPage.faq.title"))),
        React.createElement(Box, { width: "100%", maxWidth: "560px", textAlign: "left" }, Array.isArray(props.questions) &&
            props.questions.map((question, index) => (React.createElement(Accordion, { className: classes.faqAccordion, square: true, expanded: expandedIndex === index, onChange: () => setExpandedIndex(index), key: index },
                React.createElement(AccordionSummary, { expandIcon: React.createElement(KvixIcon.Chevron.Right, { style: { transform: "rotate(90deg)" } }) },
                    React.createElement(Text, { style: { fontWeight: 700 } }, question["title"])),
                React.createElement(AccordionDetails, null,
                    React.createElement(Text, null, question["text"]))))))));
};
//# sourceMappingURL=index.js.map